<template>
  <div>
    <b-card
      no-body
      class="project-locations-card"
    >

      <!-- Loading State -->
      <b-card-body
        v-if="loadLocation"
        class="text-center py-5"
      >
        <b-spinner
          variant="primary"
          class="mb-2"
        />
        <p class="text-muted mb-0">
          Loading locations data...
        </p>
      </b-card-body>

      <!-- Locations List -->
      <b-card-body v-else-if="hasLocations">
        <div class="d-flex justify-content-end align-items-end">
          <b-button
            variant="success"
            size="sm"
            @click="AddNewLocation"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="mr-1"
            />
            إضافة قطعة
          </b-button>
        </div>
        <b-tabs
          pills
          class="mt-0"
        >
          <b-tab
            v-for="(location, index) in locationsData.project_locations"
            :key="location.id"
            :title="getLocationTitle(location, index)"
          >
            <!-- Location Header -->
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h6 class="mb-1">
                  تفاصيل القطعة
                </h6>

                <b-button
                  variant="primary"
                  size="sm"
                  @click="editLocation(location)"
                >
                  <feather-icon
                    icon="EditIcon"
                    size="14"
                    class="mr-1"
                  />
                  تعديل القطعة
                </b-button>
                <div class="location-meta">
                  <small class="text-muted me-3">
                    <strong>رقم القطعة:</strong> {{ getLocationValue(location.land_number) }}
                  </small>
                  <small class="text-muted me-3">
                    <strong>أسم الحوض:</strong> {{ getLocationValue(location.block_number) }}
                  </small>
                  <small class="text-muted">
                    <strong>المساحة:</strong> {{
                      location.area ? getArea(location.area_in_feddans, location.area) : getArea(location.fields_area_in_feddans, location.fields_area)
                    }}
                  </small>
                </div>
              </div>
              <b-badge :variant="getNotesVariant(location.location_notes)">
                <span>الملاحظات:</span>
                {{ location.location_notes ? location.location_notes : 'No Notes' }}
              </b-badge>

            </div>

            <!-- Coordinates Section -->
            <div class="coordinates-section">
              <div class="d-flex justify-content-between align-items-center mb-1 flex-wrap gap-2">
                <h6 class="mb-0 font-weight-bold">
                  إحداثيات الموقع
                </h6>
                <b-button
                  v-b-tooltip.hover.top="'تحديث البيانات'"
                  variant="outline-primary"
                  size="sm"
                  :disabled="loadLocation"
                  @click="init"
                >
                  <b-spinner
                    v-if="loadLocation"
                    small
                    class="mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="RefreshCwIcon"
                    size="14"
                    class="mr-1"
                  />
                  تحديث
                </b-button>
              </div>

              <!-- Fields Coordinates -->
              <b-button
                size="sm"
                variant="primary"
                @click="addTechnicalOfficeCoordinates(location.id, 'fields')"
              >
                تحديث الإحداثيات الحقلية
              </b-button>
              <b-button
                class="ml-1 btn-sm"
                variant="primary"
                @click="exportKml(location.id)"
              >
                <span v-if="!loadExportKml">Export KML</span> <b-spinner
                  v-if="loadExportKml"
                  variant="primary"
                />
              </b-button>
              <b-button
                class="ml-1 btn-sm"
                variant="primary"
                @click="exportText(location.id)"
              >
                <span v-if="!loadExportText">Export Text</span> <b-spinner
                  v-if="loadExportText"
                  variant="primary"
                />
              </b-button>
              <div
                v-if="hasCoordinatesOfType(location.coordinates, 'fields')"
                class="mb-3"
              >
                <div class="d-flex justify-content-start  mb-1 flex-wrap gap-2">
                  <h6 class="text-muted mb-2 small">
                    <feather-icon
                      icon="MapPinIcon"
                      size="14"
                      class="mr-1"
                    />
                    إحداثيات الحقول ({{ getCoordinatesCountByType(location.coordinates, 'fields') }})
                  </h6>
                </div>
                <div class="coordinates-list">
                  <coordinate-display-card
                    :key="`fields`"
                    :coordinate="getCoordinatesByType(location.coordinates, 'fields')"
                    :title="`إحداثيات الحقول `"
                    :subtitle="`موقع ${index + 1} - ${getLocationValue(location.land_number)}`"
                    icon="MapPinIcon"
                    icon-variant="bg-primary-light"
                    icon-color="primary"
                    :show-tabs="true"
                    :show-map-button="true"
                    :project-location-id="location.id"
                    :surveying-code="project && project.surveying_code"
                    @view-on-map="viewCoordinateOnMap"
                  />
                </div>
              </div>

              <!-- Technical Office Coordinates -->
              <div class="d-flex gap-2">
                <!-- <b-button
                    size="sm"
                    variant="outline-primary"
                    @click="triggerKmlUpload(location.id)"
                    v-b-tooltip.hover.top="'رفع ملف KML لاستخراج الإحداثيات'"
                  >
                    <feather-icon icon="UploadIcon" size="14" class="mr-1"></feather-icon>
                    رفع ملف KML
                  </b-button>
                  <input
                    :ref="`kmlFileInput_${location.id}`"
                    type="file"
                    accept=".kml,.kmz"
                    style="display: none"
                    @change="handleKmlFileUpload($event, location.id)"
                  /> -->
                <!-- <b-button
                    size="sm"
                    variant="primary"
                    @click="addTechnicalOfficeCoordinates(location.id, 'technical_office')"
                  >
                    اضافة احداثيات المكتب الفني
                  </b-button> -->
              </div>
              <!-- <div v-if="hasCoordinatesOfType(location.coordinates, 'technical_office')">
                <h6 class="text-muted mb-2 small">
                  <feather-icon icon="BuildingIcon" size="14" class="mr-1"></feather-icon>
                  إحداثيات المكتب الهندسي ({{ getCoordinatesCountByType(location.coordinates, 'technical_office') }})
                </h6>
                <div class="coordinates-list">
                  <coordinate-display-card
                    :key="`technical`"
                    :coordinate="getCoordinatesByType(location.coordinates, 'technical_office')"
                    :title="`إحداثيات المكتب الهندسي #`"
                    :subtitle="`موقع ${index + 1} - ${getLocationValue(location.land_number)}`"
                    icon="BuildingIcon"
                    icon-variant="bg-danger-light"
                    icon-color="danger"
                    :show-tabs="true"
                    :show-map-button="true"
                    :project-location-id="location.id"
                    :surveying-code="project && project.surveying_code"
                    @view-on-map="viewCoordinateOnMap"
                  />
                </div>
              </div> -->

              <!-- No Coordinates Message -->
              <div
                v-if="!hasCoordinates(location.coordinates)"
                class="text-center p-4 border rounded bg-light"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="32"
                  class="text-muted mb-2"
                />
                <p class="text-muted mb-0">
                  لا توجد إحداثيات مسجلة لهذا الموقع
                </p>
              </div>
            </div>

            <!-- KML Upload Loading -->
            <div
              v-if="parsingKml && location_id === location.id"
              class="text-center p-3 border rounded bg-light mt-3"
            >
              <b-spinner
                variant="primary"
                class="mb-2"
              />
              <p class="text-muted mb-0">
                جاري معالجة ملف KML...
              </p>
            </div>

            <!-- Boundaries Section -->
            <b-card-header class="py-2">
              <h6 class="mb-0">
                الحدود
              </h6>
              <b-button
                variant="primary"
                @click="addBoundary(location.id)"
              >
                إضافة حدود
              </b-button>
            </b-card-header>
            <div v-if="location.boundaries && location.boundaries.length">
              <b-card-header class="py-2">
                <h6 class="mb-0">
                  الحدود ({{ location.boundaries.length }})
                </h6>
              </b-card-header>
              <b-card-body>
                <div class="boundaries-list">
                  <b-row>
                    <b-col
                      v-for="(boundary, bIndex) in filedsBoundries(location.boundaries)"
                      :key="boundary.id"
                      md="6"
                      sm="12"
                      class="boundary-item"
                    >
                      <!-- Boundary Header -->
                      <!-- <div class="boundary-header d-flex justify-content-between align-items-center mb-2">
                        <div class="d-flex align-items-center">
                            <b-badge :variant="getBorderDirectionVariant(boundary.border_direction)" class="me-2">
                            <i :class="getDirectionIcon(boundary.border_direction)" class="me-1"></i>
                            {{ formatBorderDirection(boundary.border_direction) }}
                            </b-badge>
                            <b-badge :variant="getBorderTypeVariant(boundary.border_type)" class="me-2 ml-1">
                            {{ formatBorderType(boundary.border_type) }}
                            </b-badge>
                        </div>
                        <div class="boundary-length">
                            <strong class="text-primary">{{ boundary.length }}m</strong>
                        </div>
                        </div> -->

                      <!-- Boundary Details -->
                      <div class="boundary-details">
                        <b-row class="g-1">
                          <b-col md="3">
                            <div class="detail-item">
                              <b-badge
                                :variant="getBorderDirectionVariant(boundary.border_direction)"
                                class="me-2"
                              >
                                <i
                                  :class="getDirectionIcon(boundary.border_direction)"
                                  class="me-1"
                                />
                                {{ formatBorderDirection(boundary.border_direction) }}
                              </b-badge>
                              <small class="text-muted">نوع الحد:</small>
                              <div class="detail-value">
                                <b-badge
                                  :variant="getBorderTypeVariant(boundary.border_type)"
                                  class="w-100"
                                >
                                  <i
                                    :class="getBorderTypeIcon(boundary.border_type)"
                                    class="me-1"
                                  />
                                  {{ formatBorderType(boundary.border_type) }}
                                </b-badge>
                              </div>
                            </div>
                          </b-col>

                          <b-col md="3">
                            <div class="detail-item">
                              <small class="text-muted">
                                {{ boundary.neighbor_name ? 'جار' : 'شارع' }}:
                              </small>
                              <div class="detail-value">
                                <span
                                  v-if="boundary.neighbor_name"
                                  class="text-dark"
                                >
                                  <i class="fas fa-user me-1 text-success" />
                                  {{ boundary.neighbor_name }}
                                </span>
                                <span
                                  v-else
                                  class="text-muted"
                                >
                                  <i class="fas fa-road me-1 text-info" />
                                  شارع
                                </span>
                              </div>
                            </div>
                          </b-col>
                          <b-col sm="3">
                            <small class="text-muted d-block">طول</small>
                            <div class="d-flex align-items-center">
                              <i class="fas fa-ruler me-1 text-primary" />
                              <strong>{{ boundary.length }} meters</strong>

                            </div>
                          </b-col>
                          <b-col
                            v-if="boundary.street_width"
                            sm="3"
                          >
                            <small class="text-muted d-block">Street Width</small>
                            <div class="d-flex align-items-center">
                              <i class="fas fa-road me-1 text-info" />
                              <span>{{ boundary.street_width }}m</span>
                            </div>
                          </b-col>
                        </b-row>

                      </div>

                    </b-col>
                  </b-row>

                </div>
              </b-card-body>
            </div>

            <!-- Location Notes -->
            <!-- <b-card v-if="location.location_notes">
              <b-card-header class="py-2">
                <h6 class="mb-0">Location Notes</h6>
              </b-card-header>
              <b-card-body>
                <p class="mb-0">{{ location.location_notes }}</p>
              </b-card-body>
            </b-card> -->

            <!-- Additional Data -->
            <b-row class="mt-3">
              <b-col
                v-if="location.elevation_data"
                md="6"
              >
                <b-card class="h-100">
                  <b-card-body class="text-center">
                    <h6>Elevation Data</h6>
                    <p class="mb-0">
                      {{ location.elevation_data }}
                    </p>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col
                v-if="location.accessibility_data"
                md="6"
              >
                <b-card class="h-100">
                  <b-card-body class="text-center">
                    <h6>Accessibility</h6>
                    <p class="mb-0">
                      {{ location.accessibility_data }}
                    </p>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card-body>

      <!-- Empty State -->
      <b-card-body
        v-else
        class="text-center py-5"
      >
        <div class="text-muted">
          <i class="fas fa-map-marker-alt fa-3x mb-3" />
          <h5>No Locations Found</h5>
          <p class="mb-0">
            This project doesn't have any locations defined yet.
          </p>
          <b-button
            variant="success"
            size="sm"
            @click="AddNewLocation"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="mr-1"
            />
            إضافة قطعة
          </b-button>
        </div>
      </b-card-body>

      <!-- Footer Actions -->
      <b-card-footer class="d-flex justify-content-between">
        <small class="text-muted">
          Last updated: {{ lastUpdateTime }}
        </small>
        <div>
          <b-button
            variant="outline-primary"
            size="sm"
            class="me-2"
            @click="exportLocationsData"
          >
            <i class="fas fa-download" /> Export Data
          </b-button>
          <!-- <b-button variant="primary" size="sm">
            <i class="fas fa-plus"></i> Add Location
          </b-button> -->
        </div>
      </b-card-footer>
    </b-card>
    <b-modal
      id="map-modal"
      v-model="showMapModal"
      title="Draw on Map"
      size="xl"
      ok-only
      ok-title="Close"
    >

      <arc-gis-map
        v-if="showMapModal"
        @polygon-created="handlePolygonCreated"
      />
    </b-modal>
    <b-modal
      id="coordinates-modal"
      v-model="showCoordinatesModal"
      title="Add technical office Coordinates"
      size="xl"
      hide-footer
      no-close-on-backdrop
      hide-header-close
      centered
    >
      <div class="d-flex justify-content-end">
        <b-button
          variant="primary"
          @click="openMapModalFor()"
        >
          رسم على الخريطة
        </b-button>
      </div>
      <b-form
        class="chat-app-form"
        @submit.prevent="submitCoordinates"
      >
        <validation-observer
          ref="modelForm"
          #default="{invalid}"
          class="w-100"
        >

          <div
            v-for="(coordinate, coordIdx) in (Array.isArray(coordinates) ? coordinates : [coordinates])"
            :key="'coord-'+coordIdx"
            class="coord-row d-flex align-items-end flex-wrap mb-1 px-2 py-2 border-bottom position-relative"
            style="background:#fff; border-radius:8px; margin-top:8px;"
          >
            <!-- <b-col md="1" ><small class="text-muted"># {{ coordIdx+1 }} </small></b-col> -->

            <b-row class="w-100">
              <b-col
                md="6"
                style="padding:0px !important"
              >
                <b-row
                  class="w-100"
                  style="padding:0px !important"
                >
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.latitude"
                      placeholder="Latitude"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.longitude"
                      placeholder="Longitude"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                md="6"
                style="padding:0px !important"
              >
                <b-row class="w-100">

                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.utm_east"
                      placeholder="UTM East"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.utm_north"
                      placeholder="UTM North"
                    />
                  </b-col>
                  <!-- <b-col  cols="5" ><b-form-input v-model="coordinate.utm_zone" placeholder="U-Zone" /></b-col> -->
                </b-row>
              </b-col>
              <b-col
                md="6"
                class="mt-1"
                style="padding:0px !important"
              >
                <b-row class="w-100">
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.etm_east"
                      placeholder="ETM East"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.etm_north"
                      placeholder="ETM North"
                    />
                  </b-col>
                  <!-- <b-col md="1" sm="4" ><b-form-input v-model="coordinate.etm_zone" placeholder="E-Zone" /></b-col> -->
                </b-row>
              </b-col>
              <b-col
                md="6"
                class="mt-1"
                style="padding:0px !important"
              >
                <b-row class="w-100">
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.dms_latitude"
                      placeholder="DMS Lat"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    style="padding-left:0px !important"
                  >
                    <b-form-input
                      v-model="coordinate.dms_longitude"
                      placeholder="DMS Lng"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <div class="w-100 d-flex justify-content-between align-items-center mt-1">
              <b-button
                size="sm"
                variant="outline-success"
                class="order-2"
                @click="addCoordinate()"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
                />
                أضف نقطة إحداثيات
              </b-button>
              <b-button
                v-if="coordinates.length > 1"
                variant="outline-danger"
                size="sm"
                class="p-1 order-1"
                @click="removeCoordinate(coordIdx)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>

            </div>
          </div>
        </validation-observer>
      </b-form>
      <div class="d-flex justify-content-end">
        <b-button
          variant="primary"
          class="rounded-pill mt-2"
          type="submit"
          @click="submitCoordinates"
        >
          حفظ
        </b-button>
        <b-button
          class="rounded-pill mt-2 ml-1"
          @click="showCoordinatesModal = false"
        >
          الغاء
        </b-button>
      </div>
    </b-modal>

    <!-- KML Preview Modal -->
    <b-modal
      id="kml-preview-modal"
      v-model="showKmlPreviewModal"
      title="معاينة إحداثيات ملف KML"
      size="xl"
      centered
      :ok-disabled="kmlCoordinates.length === 0"
      ok-title="حفظ الإحداثيات"
      cancel-title="إلغاء"
      @ok="saveKmlCoordinates"
      @cancel="kmlCoordinates = []"
    >
      <div
        v-if="kmlCoordinates.length === 0"
        class="text-center py-4"
      >
        <feather-icon
          icon="AlertCircleIcon"
          size="32"
          class="text-muted mb-2"
        />
        <p class="text-muted mb-0">
          لا توجد إحداثيات للعرض
        </p>
      </div>

      <div v-else>
        <div class="d-flex justify-content-between align-items-center mb-3">
          <b-badge
            variant="success"
            class="px-3 py-2"
          >
            <feather-icon
              icon="CheckCircleIcon"
              size="14"
              class="mr-1"
            />
            تم العثور على {{ kmlCoordinates.length }} إحداثي
          </b-badge>
        </div>

        <div
          class="kml-coordinates-preview"
          style="max-height: 400px; overflow-y: auto;"
        >
          <b-table
            :items="kmlCoordinates"
            :fields="[
              { key: 'index', label: '#' },
              { key: 'latitude', label: 'خط العرض' },
              { key: 'longitude', label: 'خط الطول' },
              { key: 'actions', label: 'إجراءات' }
            ]"
            small
            striped
            responsive
            class="mb-0"
          >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(latitude)="data">
              <code>{{ data.item.latitude.toFixed(6) }}</code>
            </template>
            <template #cell(longitude)="data">
              <code>{{ data.item.longitude.toFixed(6) }}</code>
            </template>
            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="viewCoordinateOnMap(data.item)"
              >
                <feather-icon
                  icon="MapIcon"
                  size="12"
                  class="mr-1"
                />
                عرض على الخريطة
              </b-button>
            </template>
          </b-table>
        </div>

        <!-- <div class="mt-3 p-3 bg-light rounded">
          <small class="text-muted">
            <feather-icon icon="InfoIcon" size="14" class="mr-1"></feather-icon>
            سيتم حفظ جميع الإحداثيات كإحداثيات حقول. يمكنك تعديلها لاحقاً.
          </small>
        </div> -->
      </div>
    </b-modal>
    <b-modal
      id="add-location-modal"
      v-model="showAddLocationModal"
      title="إضافة قطعة"
      size="sm"
      centered
      hide-footer
      no-close-on-backdrop
      hide-header-close
    >
      <validation-observer
        ref="addLocationModelForm"
        #default="{invalid}"
        class="w-100"
      >
        <b-row>
          <b-col
            md="6"
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="land_number"
              rules="required"
            >
              <b-form-group label="رقم القطعة">
                <b-form-input v-model="addLocationForm.land_number" />
              </b-form-group>
              <small class="text-danger float-left">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col
            md="6"
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="area"
            >
              <b-form-group label="المساحة">
                <b-form-input
                  v-model="addLocationForm.area"
                  type="number"
                  step="0.01"
                />
              </b-form-group>
              <small class="text-danger float-left">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col
            md="12"
            sm="12"
          >
            <validation-provider
              #default="{ errors }"
              name="block_number"
            >
              <b-form-group label="رقم الحوض">
                <b-form-input v-model="addLocationForm.block_number" />
              </b-form-group>
              <small class="text-danger float-left">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button
            variant="primary"
            class="rounded-pill mt-2"
            type="submit"
            @click="submitAddLocation"
          >
            حفظ
          </b-button>
          <b-button
            class="rounded-pill mt-2 ml-1"
            @click="showAddLocationModal = false"
          >
            الغاء
          </b-button>
        </div>
      </validation-observer>
    </b-modal>
    <b-modal
      id="boundary-modal"
      v-model="showBoundaryModal"
      title="الحدود"
      size="xl"
      centered
      ok-title="حفظ "
      cancel-title="إلغاء"
      @ok="saveBoundary"
    >
      <b-row>
        <b-col
          v-for="dir in [
            {key: 'southern_border', label: ' (قبلي)الحد الجنوبى'},
            {key: 'northern_border', label: ' (بحري)الحد الشمالى'},
            {key: 'eastern_border', label: 'الحد الشرقى'},
            {key: 'western_border', label: 'الحد الغربى'}
          ]"
          :key="'boundaries-' + dir.key"
          md="6"
          sm="12"
          class="mb-3  p-2 border bg-white rounded shadow-sm"
        >
          <label class="font-weight-bold">{{ dir.label }}</label>
          <b-row>
            <b-col
              md="3"
              sm="6"
            >
              <validation-provider
                #default="{ errors }"
                name="نوع الحد"
              >
                <b-form-group label="نوع الحد">
                  <v-select
                    v-model="boundary_data[0][dir.key].border_type"
                    placeholder="اختر نوع الحد"

                    :options="[
                      { value: 'جار', label: 'جار' },
                      { value: 'شارع', label: 'شارع' }
                    ]"
                    :reduce="opt => opt.value"
                    label="label"
                    :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                    :clearable="false"
                    class="w-100"
                  />
                  <small class="text-danger float-left">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- جار: show name, width. شارع: only width -->
            <b-col
              v-if="boundary_data[0][dir.key].border_type === 'جار'"
              md="6"
              sm="6"
            >
              <validation-provider
                #default="{ errors }"
                name="اسم الجار"
              >

                <b-form-group label="اسم الجار">
                  <b-form-input
                    v-model="boundary_data[0][dir.key].neighbor_name"
                    placeholder="اسم الجار"
                  />
                </b-form-group>
                <small class="text-danger float-left">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <!-- length -->
            <b-col
              md="3"
              sm="6"
            >
              <validation-provider
                #default="{ errors }"
                name="طول الحد "
              >
                <b-form-group label="طول الحد ">
                  <b-form-input
                    v-model="boundary_data[0][dir.key].length"
                    type="number"
                    placeholder="بالمتر"
                    step="0.01"
                  />
                </b-form-group>
                <small class="text-danger float-left">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              v-if="boundary_data[0][dir.key].border_type === 'شارع' "
              md="3"
              sm="6"
            >
              <validation-provider
                #default="{ errors }"
                name="عرض الشارع"
              >
                <b-form-group label="عرض الشارع ">
                  <b-form-input
                    v-model="boundary_data[0][dir.key].street_width"
                    placeholder=" بالمتر"
                    type="number"
                  />
                </b-form-group>
                <small class="text-danger float-left">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
              v-if="(boundary_data[0][dir.key].border_type === 'شارع')"
              md="3"
              sm="6"
            >
              <validation-provider
                #default="{ errors }"
                name="الردوود"
              >
                <b-form-group label="الردوود">
                  <b-form-input
                    v-model="boundary_data[0][dir.key].backs"
                    placeholder="الردوود"
                    type="number"
                  />
                </b-form-group>
                <small class="text-danger float-left">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardFooter,
  BTable,
  BButton,
  BBadge,
  BSpinner,
  BTabs,
  BTab,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BForm,
  BFormGroup,
  BModal,
  VBTooltip,

} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import CoordinateDisplayCard from '@/components/CoordinateDisplayCard.vue'
import vSelect from 'vue-select'
import ArcGisMap from '../Components/ArcGisMap.vue'

export default {
  name: 'ProjectLocations',
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardBody,
    BCardFooter,
    BTable,
    BButton,
    BBadge,
    BSpinner,
    BTabs,
    BTab,
    BRow,
    BCol,
    ArcGisMap,
    BFormInput,
    BInputGroup,
    BForm,
    BFormGroup,
    BModal,
    FeatherIcon,
    CoordinateDisplayCard,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      showBoundaryModal: false,
      boundary_data: [
        {
          southern_border: {
            border_type: null,
            neighbor_name: null,
            length: null,
            backs: null,
            street_width: null,
            type: 'fields',
          },
          northern_border: {
            border_type: null,
            neighbor_name: null,
            length: null,
            backs: null,
            street_width: null,
            type: 'fields',
          },
          eastern_border: {
            border_type: null,
            neighbor_name: null,
            length: null,
            backs: null,
            street_width: null,
            type: 'fields',
          },
          western_border: {
            border_type: null,
            neighbor_name: null,
            length: null,
            backs: null,
            street_width: null,
            type: 'fields',
          },
        },
      ],
      addLocationForm: {
        land_number: null,
        block_number: null,
        area: null,
        project_id: null,
      },
      coordinates: [{
        x: null,
        y: null,
        latitude: null,
        longitude: null,
        utm_east: null,
        utm_zone: null,
        etm_north: null,
        etm_east: null,
        etm_zone: null,
        dms_latitude: null,
        dms_longitude: null,
        type: 'technical_office',
      }],
      showMapModal: false,
      showCoordinatesModal: false,
      location_id: null,
      kmlFile: null,
      parsingKml: false,
      kmlCoordinates: [],
      showKmlPreviewModal: false,
      showAddLocationModal: false,
      editLocationId: null,
    }
  },
  computed: {
    ...mapGetters({
      locationsData: 'projects/locationsData',
      loadLocation: 'projects/loadLocation',
      loadExportKml: 'projects/loadExportKml',
      loadExportText: 'projects/loadExportText',
      project: 'projects/project',
    }),
    projectId() {
      return this.$route.params.id ? this.$route.params.id : null
    },
    locationsCount() {
      return this.locationsData?.project_locations?.length || 0
    },
    hasLocations() {
      return this.locationsCount > 0
    },
    coordinateFields() {
      return [
        { key: 'index', label: '#', thStyle: { width: '50px' } },
        { key: 'latitude', label: 'Latitude' },
        { key: 'longitude', label: 'Longitude' },
        { key: 'dms_latitude', label: 'DMS Latitude' },
        { key: 'dms_longitude', label: 'DMS Longitude' },
        { key: 'etm_east', label: 'ETM East' },
        { key: 'etm_north', label: 'ETM North' },
        { key: 'etm_zone', label: 'ETM Zone' },
        { key: 'utm_east', label: 'UTM East' },
        { key: 'utm_north', label: 'UTM North' },
        { key: 'utm_zone', label: 'UTM Zone' },
        // { key: 'coordinate_system', label: 'System', sortable: true },
        // { key: 'accuracy', label: 'Accuracy' },
        // { key: 'actions', label: 'Actions', thStyle: { width: '120px' } }
      ]
    },
    lastUpdateTime() {
      if (!this.hasLocations) return 'N/A'

      const updates = this.locationsData.project_locations
        .map(loc => new Date(loc.updated_at).getTime())
        .filter(time => !isNaN(time))

      if (updates.length === 0) return 'N/A'

      const latestUpdate = Math.max(...updates)
      return new Date(latestUpdate).toLocaleDateString()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    getArea(value, meter) {
      if (value) {
        return `${meter} م²  / ${value.feddans} فدان / ${value.qirats} قيراط / ${value.sahms} سهم`
      }
      return 'N/A'
    },
    editLocation(location) {
      this.editLocationId = location.id
      this.showAddLocationModal = true
      this.addLocationForm.project_id = this.projectId
      this.addLocationForm.id = location.id
      this.addLocationForm.land_number = location.land_number
      this.addLocationForm.block_number = location.block_number
      this.addLocationForm.area = location.area
    },
    filedsBoundries(boundaries) {
      // return when type = fields
      if (!boundaries) return []
      const $filedsBoundries = boundaries.filter(boundary => boundary.type === 'fields')

      return $filedsBoundries
    },
    addBoundary(locationId) {
      this.location_id = locationId
      this.showBoundaryModal = true
    },
    saveBoundary() {
      const payload = {
        id: this.location_id,
        query: {
          boundaries: this.boundary_data,
          boundaries_type: 'fields',
        },
      }
      this.$store.dispatch('projects/updateBoundries', payload).then(() => {
        this.$swal({
          icon: 'success',
          title: 'تم حفظ الحدود بنجاح',
          showConfirmButton: true,
          confirmButtonColor: '#06284D',
          allowOutsideClick: true,
        })
        this.init()
        this.showBoundaryModal = false
      }).catch(error => {
        this.$swal({
          icon: 'error',
          title: error.response?.data?.message || 'تعذر حفظ الحدود',
          showConfirmButton: true,
          confirmButtonColor: '#06284D',
          allowOutsideClick: true,
        })
      })
    },
    AddNewLocation() {
      // open model with just one input form land_number
      this.showAddLocationModal = true
      this.addLocationForm.project_id = this.projectId
      this.addLocationForm = {
        land_number: null,
        block_number: null,
        area: null,
        project_id: this.projectId,
      }
    },
    submitAddLocation() {
      this.$refs.addLocationModelForm.validate().then(success => {
        if (success) {
          let payload = { query: { ...this.addLocationForm } }
          if (this.editLocationId) {
            payload = { query: { ...this.addLocationForm }, id: this.editLocationId }
          }
          this.$store.dispatch('projects/addLocation', payload).then(response => {
            this.showAddLocationModal = false
            this.init()
            this.$swal({
              icon: 'success',
              title: `<h4>${response.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
            this.editLocationId = null
            this.addLocationForm = {
              land_number: null,
              block_number: null,
              area: null,
              project_id: this.projectId,
            }
          }).catch(error => {
            this.$swal({
              icon: 'error',
              title: error.response?.data?.message || 'تعذر إضافة القطعة',
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
          })
        }
      })
    },
    exportKml() {
      this.$store.dispatch('projects/exportKml', { id: this.projectId })
        .then(response => {
          // Defensive access:
          const blob = new Blob([response.data], { type: response.headers?.['content-type'] || 'application/vnd.google-earth.kml+xml' })
          const url = window.URL.createObjectURL(blob)

          // Try to parse filename from header (if present)
          let fileName = 'project.kml'
          const contentDisposition = response.headers?.['content-disposition']
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/)
            if (match && match[1]) fileName = match[1]
          }

          // Create a link for download
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)

          this.$swal({
            icon: 'success',
            title: 'تم إصدار الملف KML بنجاح',
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: error.response?.data?.message || 'تعذر تحميل الملف',
            showConfirmButton: true,
            confirmButtonColor: '#06284D',
            allowOutsideClick: true,
          })
          console.log('error', error)
        })
    },
    exportText() {
      this.$store.dispatch('projects/exportText', { id: this.projectId }).then(response => {
        let blob = response.data
        if (!(blob instanceof Blob)) {
          // Defensive, make a Blob if not already one
          console.log('NOT a Blob, wrapping as text')
          blob = new Blob([response.data], { type: 'text/plain' })
        }

        // download logic, always runs after Blob assignment
        let fileName = 'project.txt'
        const cd = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
        if (cd) {
          const match = cd.match(/filename="?([^"]+)"?/)
          if (match && match[1]) fileName = match[1]
        }

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
    },
    saveKmlCoordinates() {
      console.log('kmlCoordinates', this.kmlCoordinates)
      this.$store.dispatch('projects/storeCoordinates', {
        id: this.location_id,
        coordinates: this.kmlCoordinates,
      })
    },
    handleKmlFileUpload(event, locationId) {
      const file = event.target.files && event.target.files[0]
      if (!file) {
        this.$bvToast.toast('لم يتم اختيار ملف KML', {
          title: 'تنبيه',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.kmlFile = file
      this.location_id = locationId
      this.parsingKml = true

      const reader = new FileReader()

      reader.onload = e => {
        try {
          const kmlContent = e.target.result
          console.log('kmlContent', kmlContent)
          const coordinates = this.parseKMLContent(kmlContent)

          if (coordinates.length === 0) {
            this.$bvToast.toast('لم يتم العثور على إحداثيات في ملف KML', {
              title: 'خطأ',
              variant: 'danger',
              solid: true,
            })
            this.parsingKml = false
            return
          }

          this.kmlCoordinates = coordinates
          this.parsingKml = false
          this.showKmlPreviewModal = true

          this.$bvToast.toast(`تم استخراج ${coordinates.length} إحداثي`, {
            title: 'نجاح',
            variant: 'success',
            solid: true,
          })
        } catch (error) {
          console.error('Error parsing KML:', error)
          this.$bvToast.toast('خطأ في قراءة ملف KML', {
            title: 'خطأ',
            variant: 'danger',
            solid: true,
          })
          this.parsingKml = false
        }
      }

      reader.onerror = () => {
        this.$bvToast.toast('خطأ في قراءة الملف', {
          title: 'خطأ',
          variant: 'danger',
          solid: true,
        })
        this.parsingKml = false
      }

      reader.readAsText(file)
    },

    parseKMLContent(kmlContent) {
      const coordinates = []

      try {
        // Parse XML
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(kmlContent, 'text/xml')

        // Check for parsing errors
        const parserError = xmlDoc.getElementsByTagName('parsererror')
        if (parserError.length > 0) {
          throw new Error('ملف XML غير صالح')
        }
        console.log('xmlDoc', xmlDoc)
        // Register KML namespace
        const nsResolver = prefix => {
          const ns = {
            kml: 'http://www.opengis.net/kml/2.2',
          }
          return ns[prefix] || null
        }

        // Extract coordinates from different KML elements
        // this.extractCoordinatesFromElements(xmlDoc, 'Placemark', coordinates);
        // this.extractCoordinatesFromElements(xmlDoc, 'Point', coordinates);
        // this.extractCoordinatesFromElements(xmlDoc, 'LineString', coordinates);
        this.extractCoordinatesFromElements(xmlDoc, 'Polygon', coordinates)
        console.log('coordinates11111111111111111111', coordinates)
        // Alternative method using XPath
        // if (coordinates.length === 0) {
        //   this.extractUsingXPath(xmlDoc, coordinates);
        // }
      } catch (error) {
        console.error('KML parsing error:', error)
        // Fallback: try simple text extraction
        if (coordinates.length === 0) {
          this.extractCoordinatesFromText(kmlContent, coordinates)
        }
      }

      return coordinates
    },

    extractCoordinatesFromElements(xmlDoc, tagName, coordinatesArray) {
      const elements = xmlDoc.getElementsByTagName(tagName)

      for (const element of elements) {
        // Try to get coordinates element
        const coordElements = element.getElementsByTagName('coordinates')

        for (const coordElement of coordElements) {
          const coordsText = coordElement.textContent.trim()
          this.parseCoordinatesString(coordsText, coordinatesArray)
        }
        // Also check for coordinates directly in the element
        if (coordElements.length === 0) {
          const html = element.innerHTML
          const coordMatches = html.match(/(-?\d+\.?\d*),(-?\d+\.?\d*)/g)
          if (coordMatches) {
            coordMatches.forEach(match => {
              const [lng, lat] = match.split(',').map(Number)
              if (!isNaN(lat) && !isNaN(lng)) {
                coordinatesArray.push({
                  latitude: lat,
                  longitude: lng,
                  source: tagName,
                })
              }
            })
          }
        }
      }
    },

    extractUsingXPath(xmlDoc, coordinatesArray) {
      try {
        // Create XPath evaluator
        const evaluator = new XPathEvaluator()
        const resolver = xmlDoc.createNSResolver(xmlDoc.documentElement)

        // Try to find coordinates with namespace
        const xpath = '//*[local-name()="coordinates"]'
        const iterator = xmlDoc.evaluate(xpath, xmlDoc, resolver,
          XPathResult.ANY_TYPE, null)

        let node = iterator.iterateNext()
        while (node) {
          const coordsText = node.textContent.trim()
          this.parseCoordinatesString(coordsText, coordinatesArray)
          node = iterator.iterateNext()
        }
      } catch (error) {
        console.log('XPath not supported or failed')
      }
    },

    parseCoordinatesString(coordsText, coordinatesArray) {
      if (!coordsText) return

      // Split by spaces or newlines
      const coordPairs = coordsText.split(/\s+/)

      coordPairs.forEach(pair => {
        if (!pair.trim()) return

        // Split by comma - KML format is: longitude,latitude[,altitude]
        const parts = pair.split(',').map(Number)

        if (parts.length >= 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
          const longitude = parts[0]
          const latitude = parts[1]

          // Validate coordinate ranges
          if (latitude >= -90 && latitude <= 90
              && longitude >= -180 && longitude <= 180) {
            coordinatesArray.push({
              latitude,
              longitude,
              altitude: parts[2] || null,
              raw: pair,
            })
          }
        }
      })
    },

    extractCoordinatesFromText(kmlContent, coordinatesArray) {
      // Simple regex extraction as fallback
      const coordRegex = /(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)(?:\s*,\s*(-?\d+\.?\d*))?/g
      let match

      while ((match = coordRegex.exec(kmlContent)) !== null) {
        const longitude = parseFloat(match[1])
        const latitude = parseFloat(match[2])
        const altitude = match[3] ? parseFloat(match[3]) : null

        if (!isNaN(latitude) && !isNaN(longitude)
            && latitude >= -90 && latitude <= 90
            && longitude >= -180 && longitude <= 180) {
          coordinatesArray.push({
            latitude,
            longitude,
            altitude,
            source: 'regex',
          })
        }
      }
    },
    triggerKmlUpload(locationId) {
      const refName = `kmlFileInput_${locationId}`
      const input = this.$refs[refName]
      if (input && input[0]) {
        input[0].click()
      } else if (input) {
        input.click()
      }
    },
    getCoordinatesCount(location) {
      return location.coordinates ? location.coordinates.length : 0
    },

    getCoordinatesCountByType(coordinates, type) {
      if (!coordinates) return 0
      return coordinates.filter(coord => coord.type === type).length - 1
    },

    getCoordinatesByType(coordinates, type) {
      if (!coordinates) return []
      return coordinates.filter(coord => coord.type === type)
    },

    hasCoordinatesOfType(coordinates, type) {
      if (!coordinates) return false
      return coordinates.some(coord => coord.type === type)
    },

    hasCoordinates(coordinates) {
      return coordinates && coordinates.length > 0
    },

    viewCoordinateOnMap(coordinate) {
    // Your map viewing logic here
      console.log('View coordinate on map:', coordinate)
    },

    submitCoordinates() {
      if (!this.location_id) {
        this.$bvToast.toast('Location ID is missing', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } else {
        this.coordinates.forEach(coordinate => {
          coordinate.type = this.coordinatesType
        })
        const payload = { query: { coordinates: this.coordinates, coordinates_type: this.coordinatesType } }
        payload.id = this.location_id
        this.$store.dispatch('projects/updateCoordinates', payload)
          .then(() => {
            this.$bvToast.toast('Technical office coordinates added successfully', {
              title: 'Success',
              variant: 'success',
              solid: true,
            })
            this.showCoordinatesModal = false
            this.coordinates = [{
              x: null,
              y: null,
              latitude: null,
              longitude: null,
              utm_east: null,
              utm_zone: null,
              etm_north: null,
              etm_east: null,
              etm_zone: null,
              dms_latitude: null,
              dms_longitude: null,
              type: 'technical_office',
            }]
            this.init()
          })
          .catch(error => {
            console.error('Error adding technical office coordinates:', error)
            this.$bvToast.toast('Failed to add technical office coordinates', {
              title: 'Error',
              variant: 'danger',
              solid: true,
            })
          })
      }
    },
    openMapModalFor(idx) {
      this.showMapModal = true
    },
    handlePolygonCreated(rings, coords) {
      rings = Array.isArray(rings) ? JSON.parse(JSON.stringify(rings)) : []
      coords = Array.isArray(coords) ? JSON.parse(JSON.stringify(coords)) : []

      const ringPoints = rings[0] || []
      const latLngPoints = (coords && coords[0]) || []

      this.coordinates = ringPoints.map((point, index) => {
        const latLng = latLngPoints[index]
        const longitude = Array.isArray(latLng) ? latLng[0] : point[0]
        const latitude = Array.isArray(latLng) ? latLng[1] : point[1]

        return {
          x: point[0],
          y: point[1],
          latitude,
          longitude,
          utm_east: null,
          utm_north: null,
          utm_zone: null,
          etm_north: null,
          etm_east: null,
          etm_zone: null,
          dms_latitude: null,
          dms_longitude: null,
          type: 'technical_office',
        }
      })

      this.showMapModal = false
    },
    removeCoordinate(coordIdx) {
      this.coordinates.splice(coordIdx, 1)
    },
    addCoordinate() {
      this.coordinates.push({
        x: null,
        y: null,
        latitude: null,
        longitude: null,
        utm_east: null,
        utm_zone: null,
        etm_north: null,
        etm_east: null,
        etm_zone: null,
        dms_latitude: null,
        dms_longitude: null,
        type: 'technical_office',
      })
    },
    addTechnicalOfficeCoordinates(locationId, coordinatesType) {
      this.showCoordinatesModal = true
      this.location_id = locationId
      this.coordinatesType = coordinatesType
    },
    formatDMS(dmsString) {
      if (!dmsString) return ''

      // Fix formatting issues like "E*27.69'30"11" to "30°11'27.69\"E"
      // Add your formatting logic here based on your data source
      return dmsString.replace(/\*/g, '°').replace(/'/g, "'").replace(/"/g, '"')
    },
    getBorderDirectionVariant(direction) {
      const variants = {
        northern_border: 'primary',
        southern_border: 'success',
        eastern_border: 'warning',
        western_border: 'info',
      }
      return variants[direction] || 'secondary'
    },

    getDirectionIcon(direction) {
      const icons = {
        northern_border: 'fas fa-arrow-up',
        southern_border: 'fas fa-arrow-down',
        eastern_border: 'fas fa-arrow-right',
        western_border: 'fas fa-arrow-left',
      }
      return icons[direction] || 'fas fa-compass'
    },

    formatBorderDirection(direction) {
      const directions = {
        northern_border: 'North',
        southern_border: 'South',
        eastern_border: 'East',
        western_border: 'West',
      }
      return directions[direction] || direction
    },

    getBorderTypeVariant(type) {
      return type === 'شارع' ? 'info' : 'warning'
    },

    getBorderTypeIcon(type) {
      return type === 'شارع' ? 'fas fa-road' : 'fas fa-user-friends'
    },

    formatBorderType(type) {
      const types = {
        شارع: 'Street',
        جار: 'Neighbor',
      }
      return types[type] || type
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A'
      return new Date(dateString).toLocaleDateString()
    },

    viewBoundaryDetails(boundary) {
      console.log('View boundary details:', boundary)
      // Implement boundary details modal
    },

    editBoundary(boundary) {
      console.log('Edit boundary:', boundary)
      // Implement boundary editing
    },

    deleteBoundary(boundary) {
      console.log('Delete boundary:', boundary)
      // Implement boundary deletion with confirmation
    },
    init() {
      this.$store.dispatch('projects/getSpatialData', { id: this.projectId })
        .then(() => {
          console.log('Spatial data loaded successfully')
        })
        .catch(error => {
          console.error('Error fetching project details:', error)
          this.$bvToast.toast('Failed to load locations data', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    getLocationTitle(location, index) {
      if (location.land_number) {
        return `قطعة رقم: ${location.land_number}`
      }
      return `Location ${index + 1}`
    },
    getLocationValue(value) {
      return value || 'N/A'
    },
    getNotesVariant(notes) {
      return notes ? 'info' : 'secondary'
    },
    getCoordinatesCount(location) {
      return location.coordinates?.length || 0
    },
    viewCoordinateOnMap(coordinate) {
      console.log('View coordinate on map:', coordinate)
      this.$bvToast.toast('Opening map for coordinates', {
        title: 'Map View',
        variant: 'info',
        solid: true,
      })
    },
    exportLocationsData() {
      if (!this.hasLocations) {
        this.$bvToast.toast('No locations data to export', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        })
        return
      }

      try {
        // Prepare CSV data
        const csvRows = []

        // CSV Header
        const headers = [
          'Location #',
          'Land Number',
          'Block Number',
          'Parcel Number',
          'Location Notes',
          'Coordinate Type',
          'Latitude',
          'Longitude',
          'DMS Latitude',
          'DMS Longitude',
          'UTM East',
          'UTM North',
          'UTM Zone',
          'ETM East',
          'ETM North',
          'ETM Zone',
          'Coordinate System',
          'Boundary Direction',
          'Border Type',
          'Neighbor Name',
          'Length (m)',
          'Street Width (m)',
          'Elevation Data',
          'Accessibility Data',
        ]
        csvRows.push(headers.join(','))

        // Process each location
        this.locationsData.project_locations.forEach((location, locIndex) => {
          const locationBase = [
            locIndex + 1,
            this.getLocationValue(location.land_number),
            this.getLocationValue(location.block_number),
            this.getLocationValue(location.parcel_number),
            location.location_notes || '',
          ]

          // If location has coordinates, add them
          if (location.coordinates && location.coordinates.length > 0) {
            location.coordinates.forEach(coord => {
              const coordRow = [
                ...locationBase,
                coord.type || '',
                coord.latitude || '',
                coord.longitude || '',
                coord.dms_latitude || '',
                coord.dms_longitude || '',
                coord.utm_east || '',
                coord.utm_north || '',
                coord.utm_zone || '',
                coord.etm_east || '',
                coord.etm_north || '',
                coord.etm_zone || '',
                coord.coordinate_system || '',
                '', // Boundary fields
                '',
                '',
                '',
                '',
                '',
                location.elevation_data || '',
                location.accessibility_data || '',
              ]
              csvRows.push(coordRow.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
            })
          } else {
            // Location without coordinates
            const noCoordRow = [
              ...locationBase,
              '', '', '', '', '', '', '', '', '', '', '', '', '', // Coordinate fields
              '', '', '', '', '', '', // Boundary fields
              location.elevation_data || '',
              location.accessibility_data || '',
            ]
            csvRows.push(noCoordRow.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
          }

          // Add boundaries
          if (location.boundaries && location.boundaries.length > 0) {
            location.boundaries.forEach(boundary => {
              const boundaryRow = [
                ...locationBase,
                '', '', '', '', '', '', '', '', '', '', '', '', '', // Coordinate fields
                boundary.border_direction || '',
                boundary.border_type || '',
                boundary.neighbor_name || '',
                boundary.length || '',
                boundary.street_width || '',
                location.elevation_data || '',
                location.accessibility_data || '',
              ]
              csvRows.push(boundaryRow.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
            })
          }
        })

        // Create CSV content
        const csvContent = csvRows.join('\n')

        // Create blob and download
        const blob = new Blob([`\ufeff${csvContent}`], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.setAttribute('href', url)
        link.setAttribute('download', `project_locations_${this.projectId}_${new Date().getTime()}.csv`)
        link.style.visibility = 'hidden'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$bvToast.toast('Locations data exported successfully', {
          title: 'Success',
          variant: 'success',
          solid: true,
        })
      } catch (error) {
        console.error('Export error:', error)
        this.$bvToast.toast('Failed to export locations data', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style scoped>
.project-locations-card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.location-meta {
  font-size: 0.875rem;
}

.boundary-item:last-child {
  border-bottom: none !important;
}

::v-deep .nav-pills .nav-link {
  border-radius: 0.357rem;
  margin-bottom: 0.5rem;
}

::v-deep .table td {
  vertical-align: middle;
}

.boundaries-list {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  overflow: hidden;
}
.code-snippet {
  font-family: 'Courier New', monospace;
  background-color: #f8f9fa;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}

  .coordinates-section {
    margin-top: 1rem;
  }

  .coordinates-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .boundary-item {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  background: #fff;
  transition: all 0.3s ease;
}

.boundary-item:last-child {
  border-bottom: none;
}

.boundary-item:hover {
  background: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.boundary-header {
  padding-bottom: 0.5rem;
}

.detail-item {
  margin-bottom: 0.5rem;
}

.detail-value {
  font-weight: 500;
}

.additional-info {
  font-size: 0.875rem;
}

.boundary-actions {
  font-size: 0.8rem;
}

.action-buttons .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

/* Custom badge styles */
::v-deep .badge {
  font-size: 0.7rem;
  padding: 0.35em 0.65em;
}

/* Responsive design */
@media (max-width: 768px) {
  .boundary-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .boundary-length {
    margin-top: 0.5rem;
  }

  .boundary-actions {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .action-buttons {
    margin-top: 0.5rem;
  }
}
</style>
